<template>
  <div class="top-bar">
    <div class="page-title small">
      <div class="container">
        <h1>
          SERVICES &amp; FEES SETUP
          <div class="small" v-if="companiesViewable">
            {{ companyName }}
          </div>
        </h1>
        <div class="actions inline">
          <a :href="serviceCategoriesUrl">
            <div class="btn btn-white btn-small btn-flat">
              <div class="fa fa-tag" />
              Service Categories
            </div>
          </a>
          <a href="/companies" v-if="companiesViewable">
            <div class="btn btn-white btn-small btn-flat">
              <div class="fa fa-sitemap" />
              Companies
            </div>
          </a>
          <a href="/settings" v-else>
            <div class="btn btn-white btn-small btn-flat">
              <div class="fa fa-gears" />
              Settings
            </div>
          </a>
          <a :href="paysplitsUrl" v-if="companyPaysplits">
            <div class="btn btn-white btn-small btn-flat">
              <div class="fa fa-money" />
              Paysplits
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState('services', ['company', 'userProfile']),
    companiesViewable() {
      return ['admin', 'organization_manager'].includes(this.userProfile.type)
    },
    companyName() {
      return this.company.attributes.name
    },
    companyPaysplits() {
      return this.company.attributes.settings.enable_paysplits
    },
    paysplitsUrl() {
      return `/paysplits?company_id=${this.company.id}`
    },
    serviceCategoriesUrl() {
      return `${window.vueClientUrl}/service-categories?current_company_id=${this.company.id}`
    },
  },
  watch: {
    userProfile: function (newValue, oldValue) {
      if (!oldValue.id) {
        const companyId =
          this.$route.query.company_id || newValue.attributes.company_id
        this.$store.dispatch('services/fetchCompany', companyId)
      }
    },
  },
}
</script>
